import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../utils/firebase";

const CACHE_KEY = "allProducts";
const CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes

const useCachedProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_TTL_MS) {
          setProducts(data.filter((p) => !p.hidden));
          return;
        }
      } catch { /* invalid cache format — fall through to refetch */ }
    }

    const fetch = async () => {
      const snap = await getDocs(collection(db, "products"));
      const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })).filter((p) => !p.hidden);
      setProducts(data);
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data, timestamp: Date.now() }));
    };

    fetch();
  }, []);

  return products;
};

export default useCachedProducts;
